import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
import logo from "../dudigital.png"
const Header = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <>
      <header className="header">
        <div className="logo">
        <img 
        src={logo} 
        alt="Logo" 
        style={{ maxWidth: '300px', width: '100%', height: 'auto' }} 
      />
        </div>
        <div className="menu-icon" onClick={toggleSidebar}>
          &#9776;
        </div>
        <nav className="nav-menu">
          <Link to="/">Home</Link>
             <Link to="/about">About</Link>
          {/* <Link to="/discovery">Discovery</Link>
           <Link to="/binaryclassification">Binary Classification</Link>
          <Link to="/BinaryClassificationViz">BC Visualization</Link>
           <Link to="/enhancements">ML Enhancements</Link> */}
              <Link to="/">Results</Link>
        </nav>
      </header>
      <div className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
        <button className="close-btn" onClick={toggleSidebar}>
          &times;
        </button>
        <Link to="/" onClick={toggleSidebar}>Home</Link>
        <Link to="/" onClick={toggleSidebar}>About</Link>
        {/* <Link to="/discovery" onClick={toggleSidebar}>Discovery</Link>
          <Link to="/binaryclassification" onClick={toggleSidebar}>Binary Classification</Link>
        <Link to="/BinaryClassificationViz" onClick={toggleSidebar}>Binary Classification Visualization</Link>
         <Link to="/enhancements" onClick={toggleSidebar}>ML Enhancements</Link> */}
                <Link to="/" onClick={toggleSidebar}>Results</Link>
      </div>
      <div className={`backdrop ${sidebarOpen ? 'open' : ''}`} onClick={toggleSidebar}></div>
    </>
  );
};

export default Header;
